import React from 'react';
import MuiTypography from '@mui/material/Typography';

import { colorStringToPalette } from '@src/utils/colorStringToPalette/colorStringToPalette';
import { getTestId } from '@src/utils/testIds';
import { convertToWebProps } from '../utils.web';
import type { BaseTypographyComponent, BaseTypographyProps } from './interface';

const BaseTypography: BaseTypographyComponent = (props: BaseTypographyProps) => {
  const { color = 'text.primary', textAlign, children, $web, italic, strikethrough } = props;

  const colorValue = colorStringToPalette(color);
  const sx = {
    textDecoration: strikethrough ? 'line-through' : undefined,
  };

  // Check if formatting is explicitly being unset.
  const fontStyle = italic ? 'italic' : italic === false ? 'normal' : 'inherit';
  const fontProps = convertToWebProps(props);

  return (
    <MuiTypography
      {...fontProps}
      sx={sx}
      color={colorValue}
      component={$web.component}
      fontStyle={fontStyle}
      textAlign={textAlign}
      data-testid={getTestId(props)}
    >
      {children}
    </MuiTypography>
  );
};

export { BaseTypography };
